/* eslint-disable */
import React, { useState, useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import Alert from 'react-s-alert';
import Select from 'react-select';
import { get, getJson } from 'session';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import Drawer from '@material-ui/core/Drawer';
import { withStyles } from '@material-ui/core/styles';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import { Acl } from 'modules/common/components/Acl';
import DistributorReportModal from '../modals/DistributorReportModal';
import PreviewModal from '../modals/PreviewModal';
import ExportHistoryModal from '../modals/ExportHistoryModal';
import Pagination from 'modules/common/components/Pagination';

// import * as actions from '../../actions';
import * as actions from '../../actions';
import * as c from '../../constant';

const styles = () => ({
  dialogPaper: {
    width: '100%',
    maxWidth: '400px',
  },
});

const DistributionReport = ({ getReportList, reportList, classes, pager }) => {
  const [showSide, setShowSide] = useState(false);
  const setModal = useContext(ModalContext);
  const permissions = getJson('permissions');
  const [formData, setFormData] = useState({
    date_from: `${moment(new Date()).format('MM/DD/YYYY')}`,
    date_to: `${moment(new Date()).format('MM/DD/YYYY')}`,
  });
  const isLoading = false;

  const authProfile = getJson('profile') || {};
  const [token, setToken] = useState('');

  const handleDownload = id => {
    const path = `${
      process.env.REACT_APP_WS
    }api/v1/administrators/report_file_exports_download/${id}?bearer_token=${token}
    &email=${_.get(authProfile, 'email')}`;
    return `${path}`;
  };

  useEffect(() => {
    const getToken = get('token') || '';
    setToken(getToken);

    const datedToday = {
      date_from: `${moment(_.get(formData, 'date_from')).format('YYYY-MM-DD')}`,
      date_to: `${moment(_.get(formData, 'date_to')).format('YYYY-MM-DD')}`,
      type: 'BPLS',
    };
    getReportList(datedToday);
    // console.log(moment(new Date()).format('yyyy-MM-DD'))
  }, []);

  const handleDateChange = key => ({ target: { value } }) => {
    if (
      key === 'date_from' &&
      `${moment(new Date(value)).format('yyyy-MM-DD')}` >
        `${moment(new Date(_.get(formData, 'date_to'))).format('yyyy-MM-DD')}`
    ) {
      Alert.warning('Invalid filter, Date From is greater than Date To');

      setFormData({
        ...formData,
        [key]: '',
      });
      return;
    }

    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const handleChangeSelect = key => e => {
    setFormData({
      ...formData,
      [key]: e.value,
    });
  };

  const handleSearch = e => {
    e.preventDefault();
    getReportList({
      date_from: moment(_.get(formData, 'date_from')).format('yyyy-MM-DD'),
      date_to: moment(_.get(formData, 'date_to')).format('yyyy-MM-DD'),
      type: 'BPLS',
    });
  };

  const handlePreview = item => e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <PreviewModal
          // data={item}
          id={item.id}
        />
      ),
      title: `Distribution Report by Revenue Account`,
      modalSize: 'modal-xl',
    });
  };

  // const handleShowReport = () => e => {
  //   let args = {};
  //   if (
  //     `${moment(new Date(_.get(formData, 'date_from'))).format('yyyy-MM-DD')}` >
  //     `${moment(new Date(_.get(formData, 'date_to'))).format('yyyy-MM-DD')}`
  //   ) {
  //     Alert.warning(
  //       'Invalid filter, Date From is greater than selected Date To'
  //     );
  //     setFormData({
  //       ...formData,
  //       date_from: '',
  //     });
  //   }

  //   if (
  //     _.get(formData, 'date_from') === '' ||
  //     _.get(formData, 'date_to') === ''
  //   ) {
  //     args = {
  //       ...formData,
  //     };
  //   }
  //   if (
  //     _.get(formData, 'date_from') !== '' ||
  //     _.get(formData, 'date_to') !== ''
  //   ) {
  //     args = {
  //       ...formData,
  //       date_from: `${moment(_.get(formData, 'date_from')).format(
  //         'YYYY-MM-DD'
  //       )}`,
  //       date_to: `${moment(_.get(formData, 'date_to')).format('YYYY-MM-DD')}`,
  //     };
  //   }
  //   e.preventDefault();
  //   setModal({
  //     isOpen: true,
  //     content: (
  //       <DistributorReportModal
  //         date_from={args.date_from}
  //         date_to={args.date_to}
  //         module_type={args.module_type}
  //       />
  //     ),
  //     title: `Distribution Report by Revenue Account`,
  //     modalSize: 'modal-xl',
  //   });
  // };

  const handleExportHistory = () => e => {
    e.preventDefault();
    setShowSide(!showSide);
  };

  const handleClose = () => {
    setShowSide(false);
  };

  const handleChangePage = page => {
    const args = {
      ...formData,
      date_from: `${moment(_.get(formData, 'date_from')).format('YYYY-MM-DD')}`,
      date_to: `${moment(_.get(formData, 'date_to')).format('YYYY-MM-DD')}`,
      type: 'BPLS',
      page,
    };

    getReportList(args);
  };

  return (
    <>
      <div className="">
        <div className="row p-3">
          <div className="col-md-12 col-lg-6 col-xl-12 d-flex">
            <h3 className="row-nav font-weight-bold text-color">
              Distribution Report by Revenue Account
            </h3>
          </div>
        </div>
        <form onSubmit={handleSearch} className="mb-5">
          <div className="d-flex">
            <div className="form-input-group ml-2">
              <label className="label-reports">Export Date From</label>
              <DateInputPicker
                className="full-input"
                style={{ height: '36px' }}
                onChange={handleDateChange('date_from')}
                value={_.get(formData, 'date_from') || ''}
                maxDate={new Date(_.get(formData, 'date_to'))}
                endDate={new Date(_.get(formData, 'date_to'))}
              />
            </div>
            <div className="form-input-group ml-2">
              <label className="label-reports">Export Date To</label>
              <DateInputPicker
                className="full-input"
                style={{ height: '36px' }}
                onChange={handleDateChange('date_to')}
                value={_.get(formData, 'date_to') || ''}
                minDate={new Date(_.get(formData, 'date_from'))}
              />
            </div>
            <div className="form-input-group ml-2">
              <div className="full-input">
                <button
                  disabled={
                    _.isEmpty(_.get(formData, 'date_from')) ||
                    _.isEmpty(_.get(formData, 'date_to'))
                  }
                  type="submit"
                  className="btn btn-primary cms-bg-color-primary text-white button-distribution-report mr-2"
                >
                  <i className="fas fa-search" /> &nbsp;&nbsp;Search
                </button>
              </div>
            </div>
            {/* <div className="form-input-group ml-2">
              <div className="full-input">
                <button
                  disabled={
                    `${moment(new Date(_.get(formData, 'date_from'))).format(
                      'yyyy-MM-DD'
                    )}` >
                      `${moment(new Date(_.get(formData, 'date_to'))).format(
                        'yyyy-MM-DD'
                      )}` ||
                    (_.isEmpty(_.get(formData, 'date_from')) ||
                    _.isEmpty(_.get(formData, 'date_to')))
                  }
                  type="submit"
                  className="btn btn-primary cms-bg-color-primary font-weight-bold button-distribution-report"
                >
                  <i className="fas fa-search mr-2" /> &nbsp;&nbsp;Search
                </button>
              </div>
            </div> */}
            <div className="form-input-group ml-auto">
              <div className="full-input">
                <button
                  onClick={handleExportHistory()}
                  className="btn btn-primary cms-bg-color-primary font-weight-bold button-distribution-report"
                  type="button"
                >
                  <i className="fas fa-download mr-2" /> Export
                </button>
              </div>
            </div>
          </div>
        </form>
        {isLoading ? (
          <div
            className="loading d-flex text-center justify-content-center align-items-center"
            style={{ height: '500px' }}
          >
            <div className="spinner text-center ">
              <span className="fas fa-5x fa-spin fa-spinner" />
            </div>
          </div>
        ) : (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              // padding: "10px",
              marginBottom: '20px',
            }}
          >
            <div className="mb-3">
              {reportList.length > 0 ? (
                <div className="mt-2 table-responsive">
                  <table className="table table-striped table-sm table-bordered table-hover">
                    <thead className="table-header">
                      <tr className="billing-table-tr">
                        <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                          Date Exported
                        </th>
                        <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                          File Name
                        </th>
                        <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                          File Path
                        </th>
                        <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                          Size
                        </th>
                        <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                          Status
                        </th>
                        <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody className="table-details">
                      {reportList.map(item => {
                        return (
                          <tr
                            className="billing-table-tr"
                            key={_.get(item, 'id')}
                          >
                            <td>
                              {_.get(item, 'attributes.date_exported') || '---'}
                            </td>
                            <td>
                              {_.get(item, 'attributes.file_name') || '---'}
                            </td>
                            <td>
                              {_.get(item, 'attributes.file_path') || '---'}
                            </td>
                            <td>{_.get(item, 'attributes.size') || '---'}</td>
                            <td>{_.get(item, 'attributes.status') || '---'}</td>
                            {/* {Acl(permissions, ['DOWNLOAD E-WALLET REPORT']) && (
                                  <td>
                                    <a
                                      className="btn btn-primary cms-bg-color-primary cms-outline-primary  mr-2"
                                      href={handleDownload(item.id)}
                                      target="_blank"
                                      without="true"
                                      rel="noopener noreferrer"
                                    >
                                      <i className="fas fa-folder-open mr-2" /> Download
                                    </a>
                                  </td>
                                )} */}
                            <td className="text-center">
                              <a
                                className="btn btn-primary cms-bg-color-primary cms-outline-primary mr-2"
                                href={handleDownload(item.id)}
                                target="_blank"
                                without="true"
                                rel="noopener noreferrer"
                              >
                                <i className="fas fa-folder-open mr-2" />{' '}
                                Download
                              </a>
                              {/* <a
                                    className="btn btn-primary cms-bg-color-primary cms-outline-primary mr-2"
                                    href={handlePreview}
                                    target="_blank"
                                    without="true"
                                    rel="noopener noreferrer"
                                  >
                                    Preview
                                  </a> */}
                              <button
                                type="button"
                                onClick={handlePreview(item)}
                                className="btn-blank"
                              >
                                <i className="fas fa-eye icon-preview" />
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="d-flex align-items-center justify-content-center h-100">
                  <div className="text-center mx-auto py-4">
                    <img
                      src={emptyStateImage}
                      className="img-responsive image-wrapper mb-4 mt-3"
                      alt="Empty State"
                    />
                    <p className="emp-title mb-0">No Item Found</p>
                  </div>
                </div>
              )}
            </div>
            <div className="list-pagination">
              {pager.total_pages > 1 && (
                <div className="d-flex justify-content-center text-center align-item-center">
                  <Pagination data={pager} onChange={handleChangePage} />
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      <Drawer
        PaperProps={{ classes: { root: classes.dialogPaper } }}
        anchor="right"
        open={showSide}
        onClose={handleClose}
        style={{ width: '100%', maxWidth: '400px' }}
      >
        <ExportHistoryModal handleClose={handleClose} />
      </Drawer>
    </>
  );
};

DistributionReport.propTypes = {
  getReportList: PropTypes.instanceOf(Function).isRequired,
  reportList: PropTypes.instanceOf(Array).isRequired,
  classes: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  reportList: _.get(api, `${c.GET_REPORT_LIST}.list`) || [],
  pager: _.get(api, `${c.GET_REPORT_LIST}.pager`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default withStyles(styles)(enhance(DistributionReport));
